import signUnilaterallyDictionary from '@features/sign-unilaterally/i18n/ru/sign-unilaterally.dic.json';

export const signUnilaterally = {
  SIGN_UNILATERALLY: signUnilaterallyDictionary,
};

export const signUnilaterallyNamespaces = Object.keys(signUnilaterally);
